"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMessage = exports.formatCoin = exports.formatCoins = void 0;
var sentence_case_1 = require("sentence-case");
var formatCoins = function (data) { return data.map(exports.formatCoin).join(","); };
exports.formatCoins = formatCoins;
var formatCoin = function (_a) {
    var amount = _a.amount, denom = _a.denom;
    return "" + amount + denom;
};
exports.formatCoin = formatCoin;
var defaultMessage = function (type) {
    var result = type.split(".");
    return (0, sentence_case_1.sentenceCase)(result[result.length - 1].replace("Msg", ""));
};
exports.defaultMessage = defaultMessage;
//# sourceMappingURL=utility.js.map